export function isRussianLocale(value: string): boolean {
  return value.startsWith('ru');
}
